// Initialize slider for tablet and mobile
function initSlider() {
  if(window.innerWidth <= 1200) {
    const announcementBar = Array.from(document.querySelectorAll("#announcement")).reverse();
    const announcementEl = document.querySelector('.announcement-bar[data-slide-duration]');
    const slideDuration = announcementEl ? parseInt(announcementEl.dataset.slideDuration) : 4000;
    let currentIndex = 0;

    function showAnnouncement() {
      // Remove active and sliding classes from all announcements
      announcementBar.forEach(announcement => {
        announcement.classList.remove('announcement-bar--active', 'announcement-bar--sliding');
      });
      
      // Add active class to current announcement
      announcementBar[currentIndex].classList.add('announcement-bar--active');
      
      // Add sliding class after a brief delay to trigger animation
      setTimeout(() => {
        announcementBar[currentIndex].classList.add('announcement-bar--sliding');
      }, 50);
      
      // Update index for next announcement
      currentIndex = (currentIndex + 1) % announcementBar.length;
    }

    // Show first announcement immediately
    showAnnouncement();
    
    // Rotate announcements using the custom duration
    return setInterval(showAnnouncement, slideDuration);
  }
  return null;
}

// Initialize slider
let sliderInterval = initSlider();

// Handle window resize
window.addEventListener('resize', () => {
  // Clear existing interval if it exists
  if (sliderInterval) {
    clearInterval(sliderInterval);
    sliderInterval = null;
    
    // Reset all announcements
    document.querySelectorAll("#announcement").forEach(announcement => {
      announcement.classList.remove('announcement-bar--active', 'announcement-bar--sliding');
      announcement.removeAttribute('style');
    });
  }
  
  // Reinitialize slider if needed
  sliderInterval = initSlider();
});
